'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.locales = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _component = require('@prisma-cms/component');

var _component2 = _interopRequireDefault(_component);

var _context2 = require('@prisma-cms/context');

var _context3 = _interopRequireDefault(_context2);

var _urijs = require('urijs');

var _urijs2 = _interopRequireDefault(_urijs);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var locales = exports.locales = {
  ru: {
    values: {
      "Users": "Пользователи",
      "User": "Пользователь",
      "Reg date": "Дата регистрации"
    }
  }
};
var PageLayout = (_temp = _class = function (_PrismaCmsComponent) {
  _inherits(PageLayout, _PrismaCmsComponent);

  function PageLayout() {
    _classCallCheck(this, PageLayout);

    return _possibleConstructorReturn(this, (PageLayout.__proto__ || Object.getPrototypeOf(PageLayout)).apply(this, arguments));
  }

  _createClass(PageLayout, [{
    key: 'setPageMeta',
    // static childContextTypes = {
    //   ...PrismaCmsComponent.childContextTypes,
    //   setPageMeta: PropTypes.func,
    // }
    // getChildContext() {
    //   let context = super.getChildContext ? super.getChildContext() : {};
    //   return {
    //     ...context,
    //     setPageMeta: meta => this.setPageMeta(meta),
    //   };
    // }
    value: function setPageMeta(meta) {
      var _ref = meta || {},
          title = _ref.title,
          _ref$status = _ref.status,
          status = _ref$status === undefined ? 200 : _ref$status,
          other = _objectWithoutProperties(_ref, ['title', 'status']);

      if (!global.document) {
        global.document = {};
      }

      var _global = global,
          document = _global.document;

      if (title) {
        if (document.title !== title) {
          document.title = title;
        }
      }

      Object.assign(document, _extends({
        status: status
      }, other));
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var setMeta = this.props.setMeta;

      if (setMeta) {
        this.setPageMeta();
      }

      _get(PageLayout.prototype.__proto__ || Object.getPrototypeOf(PageLayout.prototype), 'componentWillMount', this) && _get(PageLayout.prototype.__proto__ || Object.getPrototypeOf(PageLayout.prototype), 'componentWillMount', this).call(this);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var setMeta = this.props.setMeta;

      if (setMeta) {
        this.setPageMeta();
      }

      _get(PageLayout.prototype.__proto__ || Object.getPrototypeOf(PageLayout.prototype), 'componentDidUpdate', this) && _get(PageLayout.prototype.__proto__ || Object.getPrototypeOf(PageLayout.prototype), 'componentDidUpdate', this).call(this, prevProps, prevState);
    }
  }, {
    key: 'onChange',
    value: function onChange(event) {
      var _event$target = event.target,
          name = _event$target.name,
          value = _event$target.value;
      this.setState(_defineProperty({}, name, value));
    }
  }, {
    key: 'getPage',
    value: function getPage() {
      var page = this.getUriParam("page");
      return page ? parseInt(page) : 1;
    }
  }, {
    key: 'getUriParam',
    value: function getUriParam(param) {
      var uri = this.getUri();
      var query = uri.query(true);
      return query ? query[param] : null;
    }
  }, {
    key: 'getUri',
    value: function getUri() {
      // const {
      //   // history: {
      //   // },
      //   location,
      // } = this.props;
      // const {
      //   pathname,
      //   search,
      // } = location;
      // let uri = new URI(pathname);
      // uri.query(search);
      // return uri;
      var uri = this.context.uri;
      return uri;
    }
  }, {
    key: 'getPaginationParams',
    value: function getPaginationParams() {
      var first = this.props.first;
      var page = this.getPage();
      var skip = page > 1 && first > 0 ? (page - 1) * first : undefined;
      return {
        page: page,
        skip: skip,
        first: first
      };
    }
  }, {
    key: 'getFilters',
    value: function getFilters() {
      var uri = this.context.uri;

      var _uri$query = uri.query(true),
          page = _uri$query.page,
          filters = _objectWithoutProperties(_uri$query, ['page']); // let {
      //   status_in,
      // } = uri.query(true);
      // if(status_in && !Array.isArray(status_in)){
      //   status_in = [status_in];
      // }
      // let filters = {
      //   status_in,
      // };


      return filters;
    }
  }, {
    key: 'setFilters',
    value: function setFilters(filters) {
      var _context = this.context,
          uri = _context.uri,
          history = _context.router.history;
      var newUri = uri.clone();
      var query = newUri.query(true);
      Object.assign(query, _extends({}, filters));
      newUri.query(query);
      history.push(newUri.toString());
    }
  }, {
    key: 'render',
    value: function render(content) {
      var _this2 = this; // const output = content || null


      if (!content) {
        return null;
      }

      return _react2.default.createElement(_context3.default.Consumer, null, function (context) {
        return _react2.default.createElement(_context3.default.Provider, {
          value: Object.assign(context, {
            setPageMeta: function setPageMeta(meta) {
              return _this2.setPageMeta(meta);
            }
          })
        }, content);
      });
    }
  }]);

  return PageLayout;
}(_component2.default), _class.contextType = _context3.default, _class.propTypes = _extends({}, _component2.default.propTypes, {
  setMeta: _propTypes2.default.bool.isRequired
}), _class.defaultProps = _extends({}, _component2.default.defaultProps, {
  setMeta: true,
  locales: locales
}), _temp);
exports.default = PageLayout;